import cachedState from '@/cachedState'
import CommerceEventsClient from './CommerceEventsClient'
import CommerceEventsTracker from './CommerceEventsTracker'

export default function init(app) {
  if (cachedState.prerendering()) {
    return null
  }

  app.analytics.commerceEvents = new CommerceEventsTracker(
    app,
    new CommerceEventsClient()
  )
  app.analytics.commerceEvents.install()

  return app.analytics.commerceEvents
}
